// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"263":"ac220dd0","701":"24ea15f9"}[chunkId] + ".chunk.css";
};